/* eslint-disable max-len */
// import types from '../types'
import Helpers from '../Helpers'

export const submitUserFeedback = (moduleId, taskId, answer) => (dispatch, getState) => {
  const uid = getState().userReducer?.user?.uid || ''
  const header = {
    uid,
  }
  const data = {
    'moduleId': moduleId,
    'taskId': taskId,
    'user_input': answer,
  }
  Helpers.fetchPostJson(process.env.REACT_APP_ATLS + 'input', data, header)
      .then((res) => {
        console.log(res)
      })
      .catch((err) => {
        console.log(err)
      })
}
